import { render, staticRenderFns } from "./tablist1.vue?vue&type=template&id=03bc6c30&scoped=true&"
import script from "./tablist1.vue?vue&type=script&lang=js&"
export * from "./tablist1.vue?vue&type=script&lang=js&"
import style0 from "./tablist1.vue?vue&type=style&index=0&id=03bc6c30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc6c30",
  null
  
)

export default component.exports